/** Map the Ask AI API confidence enum onto the chip. Medium must not read as High. */
export function presentAskAiConfidence(apiValue) {
    if (apiValue === 'HIGH') return { score: 0.9, label: 'High' };
    if (apiValue === 'MED') return { score: 0.55, label: 'Medium' };
    return { score: 0.4, label: 'Low' };
}
